import React from "react";
import { Box } from "@chakra-ui/react";
import FormModal from "./FormModal";

const ActionModal = ({
  isOpen,
  setIsOpen,
  deleteItem,
  action,
  title,
  text,
  actionButtonText,
}) => {
  const handleSubmit = () => {
    action(deleteItem);
    setIsOpen(false);
  };

  return (
    <FormModal
      title={title}
      action={() => handleSubmit()}
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      isSubmitting={false}
      actionButton={actionButtonText}
    >
      <Box w="100%" mr="1">
        {text}
      </Box>
    </FormModal>
  );
};

export default ActionModal;
